import { FluidObject } from "gatsby-image"
import React, { useContext } from "react"
import Slider from "react-slick"
import styled, { css } from "styled-components"
import { UIContext } from "../../components/shared/layout"
import { IBreakpointImageVariants } from "../atoms/breakpoint-image"
import Button from "../atoms/button"
import { Block, Grid, Spacer } from "../atoms/layout-primitives"
import Text, { T } from "../atoms/text"
import BlogCard from "../molecules/resource-card"
import {
  DividingLine,
  PostContainer,
  TitleContainer,
} from "../styles/blog-card-grid.style"
import InternalRoutes from "../util/internal-routes"

export interface IBlogCard {
  fluidImage?: FluidObject
  imageVariants?: IBreakpointImageVariants
  title: string
  description: string
  link: string
  resourceName?: string
}

interface IBlogCardGrid {
  title?: string
  blogCardDetails: IBlogCard[]
  divider?: boolean
}

const BlogCardGrid = ({
  title,
  blogCardDetails,
  divider = true,
}: IBlogCardGrid) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  return (
    <>
      <Grid>
        <TitleContainer>
          <Text
            as="h2"
            variants={[
              css`
                ${T.sm.h2(500)};
                text-align: center;
              `,
              css`
                ${T.md.h2(500)};
              `,
              css`
                ${T.lg.h2(500)};
              `,
            ]}
          >
            {title}
          </Text>
        </TitleContainer>
        <PostContainer
          col={{ sm: "1 / -1", md: "2 / -2", lg: "1 / -1" }}
          display={{ sm: "flex" }}
          variants={{
            md: css`
              max-width: 540px;
              justify-self: center;
            `,
            lg: css`
              max-width: 100%;
            `,
          }}
        >
          {breakpoint === "lg"
            ? blogCardDetails.map((blog) => (
                <BlogCard
                  key={blog.link}
                  imageVariants={
                    blog.imageVariants
                      ? blog.imageVariants
                      : { sm: blog.fluidImage } // A lot of blog grids only have 1 image
                  }
                  title={blog.title}
                  resourceName={blog.resourceName}
                  description={blog.description}
                  link={blog.link}
                />
              ))
            : clientLoaded && (
                <Slider dots arrows>
                  {blogCardDetails.map((blog) => (
                    <BlogCard
                      key={blog.link}
                      imageVariants={
                        blog.imageVariants
                          ? blog.imageVariants
                          : { sm: blog.fluidImage }
                      }
                      title={blog.title}
                      description={blog.description}
                      resourceName={blog.resourceName}
                      link={blog.link}
                    />
                  ))}
                </Slider>
              )}
        </PostContainer>
        <Spacer height={{ sm: "72px", lg: "48px" }} />
        <Block>
          <Button.Link
            variants={{ sm: { margin: "0 auto" } }}
            to={InternalRoutes.Blog()}
            target="_blank"
          >
            Read Our Blog
          </Button.Link>
        </Block>
        {divider && <DividingLine />}
      </Grid>
    </>
  )
}

export default styled(BlogCardGrid)``
